<template>
	<div>
		<CAppInsights ref="ai" />
		<button
			id="open-dialog-button"
			class="button button--primary sz-4"
			@click="openDialog()"
		>
			<slot name="button-text" />
		</button>
		<slot name="description" />
	</div>
</template>
<script lang="ts">
	import { refreshSession } from '@cognitoforms/api/services/session';
	import CAppInsights from 'src/components/embeds/AppInsights';
	import { defineComponent, ref } from 'vue';
	import { useRoute } from 'vue-router/composables';
	export default defineComponent({
		name: 'AuthWithinFrame',
		components: {
			CAppInsights
		},
		props: { pageSource: { type: String, default: '' } },
		setup(props) {
			const ai = ref(null);
			const route = useRoute();
			const openDialog = () => {
				// Fix for IE returning null for window.origin
				if (!window.origin)
					window.origin = `${window.location.protocol}//${window.location.hostname}` + (`${window.location.port}` ? `:${window.location.port}` : '');

				const paths = [window.origin + route.fullPath, // expected path
					(window.origin + route.fullPath).replace(props.pageSource, props.pageSource === 'signup' ? 'login' : 'signup'), // if they switch
					(window.origin + route.fullPath).replace(props.pageSource, 'auth/forgot-password') // forgot password route
				];
				const dialog = window.open(paths[0], `Cognito Forms ${props.pageSource}`, 'width=800,height=800');
				if (!dialog)
					return;

				dialog.onload = () => {
					const isComplete = () => {
						try {
							return !paths.includes(dialog.location.href);
						}
						catch (e) {
							return false;
						}
					};
					const interval = setInterval(() => {
						if (!dialog || dialog.closed) {
							console.warn('Closed dialog without logging in');
						}
						else if (isComplete()) {
							clearInterval(interval);
							const returnUrl = dialog.location.href;
							dialog.close();
							refreshSession().then(session => {
								if (session.isAuthenticated) {
									window.location.href = returnUrl;
								}
								else if (ai.value.appInsights)
									ai.value.appInsights.trackException(new Error('Failed to authenticate within iframe'));
							});
						}
					}, 500);
				};
			};

			openDialog();

			return {
				openDialog,
				ai
			};
		}
	});
</script>